var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded && _vm.model
    ? _c(
        "div",
        { staticClass: "pb-4" },
        [
          true
            ? _c(
                "b-card",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center w-100"
                              },
                              [
                                _c("h3", [_vm._v("Formulário")]),
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "outline-secondary" },
                                    on: { click: _vm.goBack }
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: { icon: "CornerUpLeftIcon" }
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "align-middle" },
                                      [_vm._v(_vm._s(_vm.$t("back")))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3705269757
                  )
                },
                [
                  _c("formula", {
                    attrs: {
                      "form-definition": _vm.model.data,
                      "view-only": "",
                      value: _vm.model.data.data
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          true
            ? _c(
                "b-card",
                { attrs: { id: "attachments", title: "Anexos" } },
                [
                  _c("media-list", {
                    attrs: { "show-delete": false, medias: _vm.model.media },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "prepend",
                          fn: function(prepend) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-center items-center pl-2"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-lg text-primary",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.scrollTo(
                                            "a" +
                                              prepend.media.attachment_number
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "[" +
                                          _vm._s(
                                            prepend.media.attachment_number
                                          ) +
                                          "]"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2823354164
                    )
                  }),
                  _vm.model.media.length === 0
                    ? _c(
                        "div",
                        { staticClass: "flex items-center" },
                        [
                          _c("feather-icon", {
                            staticClass: "h-5 w-5 mr-1",
                            attrs: { icon: "InfoIcon" }
                          }),
                          _c("span", [_vm._v("Nenhum anexo encontrado.")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "w-full flex gap-2 justify-end" },
            [
              _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.goBack }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "CornerUpLeftIcon" }
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("back")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }